var Serp = (function ($) {

    var getPDPLink = function (elem) {
        return elem.closest("div.search-list-row").find('div.choice-button a.result-list-prod-button-details').attr("href");
    };

    var getPDPLinkForMotoTyre = function (elem) {
        return elem.closest("div.tyre_infobox").find('div.product-cart-details a.result-list-prod-button-details').attr("href");
    };

    var getPDPLinkForCompareTyre = function (elem) {
        return elem.closest("div.compare-product-container").find('div.comparison-top-actions a.comparison-product-link').attr("href");
    };

    function init(clientReviewSection) {
        if (!$(".productListComponent").first().length && !$(".moto-tyre-group").length && !$(".compare-column").length) {
            return;
        }
        if(IsMobile.any()) {
            var clientsReviews = $(".client-reviews-rating-section .client-reviews");
            if (clientsReviews.length) {
                clientsReviews.css("pointer-events", "none");
            }
        }

        if (clientReviewSection) {
            clientReviewSection.on('click', function (event) {
                event.preventDefault();
                redirectToPDP($(this), getPDPLinkForCompareTyre);
            });
            return;
        }

        $(".client-reviews-rating-section").on('click', function (event) {
            event.preventDefault();
            redirectToPDP($(this), getPDPLink);
            redirectToPDP($(this), getPDPLinkForMotoTyre);
            redirectToPDP($(this), getPDPLinkForCompareTyre);
        });
    }
    var redirectToPDP = function ($this, getPdpLink) {
        var link = getPdpLink($this);
        if (link === undefined) {
            return;
        }
        link += "#clients-reviews-tab";
        window.location.href = link;
    };

    var addTyreToCompareHandlers = function () {
        window.THEME.$document.on('addRedirectPDPLinkToClientReviewSection', function() {
            init($("#comparisonContainer .client-reviews-rating-section"))
        });
    };

    return {
        init: init,
        addTyreToCompareHandlers: addTyreToCompareHandlers,
        setPDPLinkProvider: function (provider) {
            getPDPLink = provider;
        }
    };

})($);

$(function () {
    Serp.init();
    Serp.addTyreToCompareHandlers();
});